import { render, staticRenderFns } from "./TagCheck.vue?vue&type=template&id=0a1f136c&"
import script from "./TagCheck.vue?vue&type=script&lang=js&"
export * from "./TagCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports